var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCardBofa = function SvgCardBofa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "card-bofa_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".card-bofa_svg__st2{fill:#e31837}.card-bofa_svg__st3{fill:#012169}")), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h32a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.293.293 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582zm3.53-.768c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#e6e1da"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "card-bofa_svg__st2",
    d: "M33.084 15.747c1.548-1.323 3.722-2.61 4.916-3.073a19.372 19.372 0 0 0-.796-.471c-1.541.507-3.339 1.632-4.946 2.904.274.207.561.42.826.64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "card-bofa_svg__st3",
    d: "M32.377 12.153c-.229-.11-.479-.213-.671-.301-.582.287-1.342.72-2.3 1.404.206.11.428.243.663.375.738-.545 1.482-1.059 2.308-1.478z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "card-bofa_svg__st2",
    d: "M33.755 11.52c-.28-.154-1.253-.514-1.924-.669a17.33 17.33 0 0 0-.671.265c.243.066 1.15.309 1.924.698.199-.095.479-.213.671-.294z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "card-bofa_svg__st3",
    d: "M30.46 11.425a20.5 20.5 0 0 0-2.263 1.257c.177.081.354.147.597.265 1.091-.735 1.946-1.183 2.285-1.33-.243-.089-.471-.148-.619-.192z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "card-bofa_svg__st2",
    d: "M34.403 11.292c.199-.066.427-.125.626-.184a14.16 14.16 0 0 0-1.946-.662c-.103.029-.413.11-.627.176.223.068.952.237 1.947.67zm-3.633 2.765c.236.14.486.331.73.492 1.614-1.25 3.206-2.213 4.953-2.757a34.997 34.997 0 0 0-.73-.368c-1.047.265-2.838.978-4.953 2.633z"
  })));
};
export default SvgCardBofa;